
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as _91_46_46_46all_93DcA_RHQVlPJpKWiD__KZ_458Qes8AMu1_45XSqY1n2_B_45s4Meta } from "/vercel/path0/pages/[...all].vue?macro=true";
import { default as indexEgFWtugTke_irztuqE1Uyhomq7ZhZsbOa_45HhVu7IwxMMeta } from "/vercel/path0/pages/fat/index.vue?macro=true";
import { default as indexO_XMFpvEqRTQrnaW84JeaD5NyssGNu8oRcT2uKc4CiwMeta } from "/vercel/path0/pages/city/index.vue?macro=true";
import { default as log_45in7UcYu7T32ekwMHI68voREVzz7LVqSwR3Vxoa8B0i40QMeta } from "/vercel/path0/pages/auth/log-in.vue?macro=true";
import { default as verify6_45I8cX1jaJz3uY6CJFj0j3CvlWxgb3Td5_45TEpRstv_YMeta } from "/vercel/path0/pages/auth/verify.vue?macro=true";
import { default as indexkRJ0JR1v5pfrxhF_45L_45kUDZCZlHhFHYHPG9GdXlsQn1UMeta } from "/vercel/path0/pages/posts/index.vue?macro=true";
import { default as log_45outvtUgBVy8Zv5HgwoHLyJTyzvc8LMxwZtWfxazOmNqY7gMeta } from "/vercel/path0/pages/auth/log-out.vue?macro=true";
import { default as index5m4luOcQHke3VZrEYSUnzYkzST3dh3H3ZkRLIEILJ48Meta } from "/vercel/path0/pages/events/index.vue?macro=true";
import { default as indexqoKSeLIEiJ7mOMk20JNLL4HbqjBz48ERZZZwSiRaQvYMeta } from "/vercel/path0/pages/offers/index.vue?macro=true";
import { default as singleVswSjFGns_45WVxX9eqrSTnTUz1DyRtVFqo_ixwAMn0ssMeta } from "/vercel/path0/pages/posts/single.vue?macro=true";
import { default as indexTkFtT1OXARLa9LfgaRkqE19_45aZw9CkVMwWjVPxVJp2UMeta } from "/vercel/path0/pages/search/index.vue?macro=true";
import { default as profilen4LEkq9PZcDRMEHuGEfxZbM3GdGDA4apt_qlaOdQY9sMeta } from "/vercel/path0/pages/user/profile.vue?macro=true";
import { default as _91city_93u2j9sf3W3gNiOzIucZ_zkzQtpATR5FVZqjIznxpu_45OIMeta } from "/vercel/path0/pages/events/[city].vue?macro=true";
import { default as _91city_93YqHumUUVhODEoNs33sBVYz9URG0aCopmITKj_T8nrbIMeta } from "/vercel/path0/pages/offers/[city].vue?macro=true";
import { default as index13WCFwmfaEaGM_45EbrtowvXri_45sYaJ3Tm6WIsUYWkuEUMeta } from "/vercel/path0/pages/res-req/index.vue?macro=true";
import { default as indexA3gAnHil6NAbO9fQFT05eCXtOspgdDuHHS7lEwCry_45IMeta } from "/vercel/path0/pages/campaigns/index.vue?macro=true";
import { default as indexiFEnex6ty225NkJg4t6Jpgjzr758BXzNQHpWAQLZ9uMMeta } from "/vercel/path0/pages/giftcards/index.vue?macro=true";
import { default as _91city_93lWZ9MG54CvrB__45GzHxg5UmgoKt0GzrwAQ5kNwH8qnDoMeta } from "/vercel/path0/pages/giftcards/[city].vue?macro=true";
import { default as _91tag_93T7pJzPZjzLIhsV_2y6iL4DLJlDcrQ39v06SN3Z4w0s0Meta } from "/vercel/path0/pages/restaurants/[tag].vue?macro=true";
import { default as indexksYZQSM5fF6dKPzXRGxEF3AvjhKDSKWgCR0f_9jiCPEMeta } from "/vercel/path0/pages/restaurants/index.vue?macro=true";
import { default as _91city_93RTHoeEXf5dhEETArIS6hX9QjtjJ8wyqfgtfs_ywjN4QMeta } from "/vercel/path0/pages/restaurants/[city].vue?macro=true";
import { default as _91slug_93WZ1OAL9tUGV1PXTL8pOZGcX40g8ETIuxX6WHgZxRCa8Meta } from "/vercel/path0/pages/restaurants/[slug].vue?macro=true";
import { default as skaldjursveckornagNazDVHGO6QYp22i5O7V8iwhGo1r4pQDQ28l9s9TtbEMeta } from "/vercel/path0/pages/campaigns/skaldjursveckorna.vue?macro=true";
import { default as stockholm_45food_45weeks61bLbJZ9Ssn7o4_454bgwPFap49b2a7MP_oKwMBVwiVOkMeta } from "/vercel/path0/pages/campaigns/stockholm-food-weeks.vue?macro=true";
export default [
  {
    name: "start",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "all",
    path: "/:all(.*)*",
    component: () => import("/vercel/path0/pages/[...all].vue")
  },
  {
    name: "fat",
    path: "/lediga-bord",
    meta: {"middleware":"fat"},
    component: () => import("/vercel/path0/pages/fat/index.vue")
  },
  {
    name: "city",
    path: "/city",
    component: () => import("/vercel/path0/pages/city/index.vue")
  },
  {
    name: "auth-log-in",
    path: "/logga-in",
    component: () => import("/vercel/path0/pages/auth/log-in.vue")
  },
  {
    name: "auth-verify",
    path: "/verifiera",
    component: () => import("/vercel/path0/pages/auth/verify.vue")
  },
  {
    name: "posts",
    path: "/posts",
    component: () => import("/vercel/path0/pages/posts/index.vue")
  },
  {
    name: "auth-log-out",
    path: "/logga-ut",
    component: () => import("/vercel/path0/pages/auth/log-out.vue")
  },
  {
    name: "events",
    path: "/evenemang",
    component: () => import("/vercel/path0/pages/events/index.vue")
  },
  {
    name: "offers",
    path: "/erbjudanden",
    meta: {"middleware":"offers"},
    component: () => import("/vercel/path0/pages/offers/index.vue")
  },
  {
    name: "posts-single",
    path: "/posts/single",
    component: () => import("/vercel/path0/pages/posts/single.vue")
  },
  {
    name: "search",
    path: "/sok",
    component: () => import("/vercel/path0/pages/search/index.vue")
  },
  {
    name: "user-profile",
    path: "/profil",
    component: () => import("/vercel/path0/pages/user/profile.vue")
  },
  {
    name: "events-city",
    path: "/evenemang/:city()",
    component: () => import("/vercel/path0/pages/events/[city].vue")
  },
  {
    name: "offers-city",
    path: "/erbjudanden/:city()",
    meta: {"middleware":"offers"},
    component: () => import("/vercel/path0/pages/offers/[city].vue")
  },
  {
    name: "res-req",
    path: "/bokningsforfragan",
    component: () => import("/vercel/path0/pages/res-req/index.vue")
  },
  {
    name: "campaigns",
    path: "/exclusive",
    component: () => import("/vercel/path0/pages/campaigns/index.vue")
  },
  {
    name: "giftcards",
    path: "/presentkort",
    component: () => import("/vercel/path0/pages/giftcards/index.vue")
  },
  {
    name: "giftcards-city",
    path: "/presentkort/:city()",
    component: () => import("/vercel/path0/pages/giftcards/[city].vue")
  },
  {
    name: "restaurants-city-tag",
    path: "/restauranger/:city()/:tag()",
    component: () => import("/vercel/path0/pages/restaurants/[tag].vue")
  },
  {
    name: "restaurants",
    path: "/restauranger",
    component: () => import("/vercel/path0/pages/restaurants/index.vue")
  },
  {
    name: "restaurants-city",
    path: "/restauranger/:city()",
    component: () => import("/vercel/path0/pages/restaurants/[city].vue")
  },
  {
    name: "restaurants-slug",
    path: "/restaurang/:slug()",
    component: () => import("/vercel/path0/pages/restaurants/[slug].vue")
  },
  {
    name: "campaigns-skaldjursveckorna",
    path: "/exclusive/skaldjursveckorna",
    component: () => import("/vercel/path0/pages/campaigns/skaldjursveckorna.vue")
  },
  {
    name: "campaigns-stockholm-food-weeks",
    path: "/exclusive/stockholm-food-weeks",
    component: () => import("/vercel/path0/pages/campaigns/stockholm-food-weeks.vue")
  }
]